<script lang="ts">
  import type {HistoryItem} from "../../../types/global";
  import HistoryDurationIcon from "../../interactive/HistoryDurationIcon.svelte";
  import ArrowRightIcon from "../../interactive/ArrowRightIcon.svelte";
  import HistoryCheckbox from "../../interactive/HistoryCheckbox.svelte";
  import {SqrlQaId} from "../../../constants/squirrel";
  import {historyViewMode} from "../../../store/HistoryStore";
  import {SUBMIT_TYPE, submitStore} from "../../../store/SubmitStore";
  import {SqrlUrl} from "../../../util/SqrlUrl";
  import {tlSearchType} from "../../../tracking/labels/SearchType";
  import {TL_HIGGINS} from "../../../tracking/labels/higginsLabel";
  import {SEARCH_TYPE} from "../../../constants/searchType";
  import type {TrackingData} from "../../../types/tracking";

  export let search: HistoryItem;
  export let index: number;

  function handleSubmit(event: Event) {
    event.preventDefault();
    const trackingData: TrackingData = {
      [tlSearchType.name]: SEARCH_TYPE.HISTORY,
      [TL_HIGGINS.ACTIVE_SEARCH]: "true",
      [TL_HIGGINS.INITIAL_SEARCH]: "true",
      [TL_HIGGINS.INTERACTION]: "initial_search",
      [TL_HIGGINS.SEARCH_HISTORY]: "exists",
      [TL_HIGGINS.SUGGEST_POS]: `${index + 1}`,
    }
    const fallbackTarget: SqrlUrl = new SqrlUrl(`${window.location.origin}/suche/${search.term}`)
    submitStore.handleSubmit(search.term, fallbackTarget.urlWithRef(trackingData), SUBMIT_TYPE.HISTORY_ITEM)
  }
</script>

<li class="squirrel_searchHistory" data-qa-id={SqrlQaId.HISTORY_ITEM} role="listitem">
    <div class="squirrel_searchHistory__text js_squirrel_searchHistory"
         data-qa-id={SqrlQaId.HISTORY_ITEM_ROW}>
        {#if $historyViewMode}
            <HistoryDurationIcon/>
        {:else}
            <HistoryCheckbox {search} {index}/>
        {/if}
        <span class="pl_copy100 squirrel_searchHistory__term js_squirrel_searchHistory__term"
              data-term={search.term}
              data-pos={index} on:click={handleSubmit}>{search.term} </span>
        <oc-icon-v1 type="arrow-right" size="100" color="#f00020" on:click={handleSubmit}></oc-icon-v1>
    </div>
</li>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;
  @use "~@otto-ec/global-frontend-settings/scss/font-size" as fonts;
  @use "~@otto-ec/global-frontend-settings/scss/variables" as variables;

  .squirrel_searchHistory {
    position: relative;
    cursor: pointer;
    background-color: white;
    padding: 0 16px;

    &:not(:last-child) {
      > div {
        border-bottom: 1px solid pl_variables.$pl_color-grey25;
      }
    }

    &__text {
      @include fonts.font-size(variables.$font100, false);

      /*                                                  */
      padding: 12px 0;
      display: flex;
      height: 48px;


      .squirrel_searchHistory__term {
        flex: 1;
        height: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
      }
    }

    /*           */
    /*                   */
    //}

    &:hover {
      background-color: pl_variables.$pl_color-grey25;
    }
  }
</style>
